const initialState = {
  data: [],
  selections: {
    chosenSize: '',
    sizeText: '',
    amount: 1,
    discount: null,
  },
  priceMatch: '',
  messages: {
    sizeError: '',
  },

  customization_url: null,
  fetchingState: false,
  customization: {
    number: '',
    select: null,
    text: '',
    checkbox: null,
  },
  allData: {},
  customizationAdded: false,
  isCustomizationOpen: false,
  productID: '',
  lineID: '',
};

export default (state = { ...initialState }, action) => {
  switch (action.type) {
    case 'INITIAL_DATA':
      return {
        ...state,
        data: action.initialData,
      };
    case 'ADD_SIZE': {
      const { sizeDetails } = action;
      return {
        ...state,
        selections: {
          ...state.selections,
          sizeDetails,
        },
        messages: {
          ...state.messages,
          sizeError: '',
        },
      };
    }
    case 'UPDATE_AMOUNT':
      return {
        ...state,
        selections: {
          ...state.selections,
          amount: action.payload.amount,
          discount: action.payload.discount,
        },
      };
    case 'PRICE_MATCH':
      return {
        ...state,
        priceMatch: action.text,
      };
    case 'SIZE_NOT_PICKED':
      return {
        ...state,
        messages: {
          ...state.messages,
          sizeError: action.payload.message,
        },
      };
    case 'ADD_UNIID_LINK':
      return {
        ...state,
        customization_url: action.payload,
      };
    case 'ADD_CUSTOMIZATION_LIST': {
      const { customizationList, allData } = action;
      return {
        ...state,
        customization: {
          ...state.customizationList,
          customizationList,
        },
        allData,
        customizationAdded: true,
      };
    }
    case 'SELECTING_CUSTOMIZATION':
      return {
        ...state,
        isCustomizationOpen: action.payload,
      };
    case 'UNSELECT_CUSTOMIZATION':
      return {
        ...state,
        isCustomizationOpen: false,
      };
    case 'CLEAR_CUSTOMIZATION': {
      return {
        ...state,
        customization: initialState.customization,
        allData: {},
        customizationAdded: initialState.customizationAdded,
        isCustomizationOpen: initialState.isCustomizationOpen,
      };
    }
    case 'FETCH_AND_REPLACE_STATE':
      return {
        ...initialState,
        data: action.newState,
      };
    case 'FETCHING_AND_REPLACING_STATE':
      return {
        ...state,
        fetchingState: true,
      };
    default:
      return state;
  }
};
